// extracted by mini-css-extract-plugin
export default {"entry":"Experience_entry__FlMzT","role":"Experience_role__mH2pJ","range":"Experience_range__QER7Y","place":"Experience_place__EhCW2","achievements":"Experience_achievements__LxbyP"};